<template>
  <div class="section text-center">
    <div class="container">
      <div class="md-layout md-layout-item">
        <div
          class="md-layout-item md-large-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-100 d-flex"
        >
          <md-card class="mb-0">
            <div class="mx-auto cyan-900">
              <!-- <i class="fa fa-diagnoses fa-7x"></i> -->
              <md-icon class="md-size-5x cyan-900">manage_accounts</md-icon>
            </div>
            <h4 class="card-title">{{ $t("cards-sections.title-first") }}</h4>
            <md-card-content>
              <p class="card-description">
                {{ $t("cards-sections.description-first") }}
              </p>
            </md-card-content>
          </md-card>
        </div>
        <div
          class="md-layout-item md-large-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-100 upper-space d-flex"
        >
          <md-card class="mb-0">
            <div class="mx-auto upper-space cyan-900">
              <!-- <i class="fa fa-cogs fa-7x"></i> -->
              <md-icon class="md-size-5x md-size-5x-gear cyan-900"
                >settings</md-icon
              >
            </div>
            <h4 class="card-title">
              {{ $t("cards-sections.title-second") }}
            </h4>
            <md-card-content>
              <p class="card-description">
                {{ $t("cards-sections.description-second") }}
              </p>
            </md-card-content>
          </md-card>
        </div>
        <div
          class="md-layout-item md-large-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-100 d-flex"
        >
          <md-card class="mb-0">
            <div class="mx-auto cyan-900">
              <!-- <i class="fa fa-sign-out-alt fa-7x"></i> -->
              <md-icon class="md-size-5x cyan-900">logout</md-icon>
            </div>
            <h4 class="card-title">{{ $t("cards-sections.title-third") }}</h4>
            <md-card-content>
              <p class="card-description">
                {{ $t("cards-sections.description-third") }}
              </p>
            </md-card-content>
          </md-card>
        </div>
        <div
          class="md-layout-item md-large-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-100 d-flex"
        >
          <md-card class="mb-0">
            <div class="mx-auto cyan-900">
              <!-- <i class="fa fa-search-dollar fa-7x"></i> -->
              <md-icon class="md-size-5x cyan-900">credit_score</md-icon>
            </div>
            <h4 class="card-title">
              {{ $t("cards-sections.title-fourth") }}
            </h4>
            <md-card-content>
              <p class="card-description">
                {{ $t("cards-sections.description-fourth") }}
              </p>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardsSection",
};
</script>
